import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export function useQueryParam(param) {
  const query = useQuery();
  return query.get(param);
}

export function useNumericQueryParam(param, defaultValue = 0) {
  const query = useQuery();
  const value = query.get(param);
  return value == null || isNaN(value) ? defaultValue : parseInt(value);
}

export function useListQueryParam(param, defaultValue = []) {
  const query = useQuery();
  const value = query.get(param);
  return value == null
    ? defaultValue
    : value
        .split(",")
        .map((v) => parseInt(v))
        .filter((v) => !isNaN(v));
}

export function useSetParam() {
  const query = useQuery();
  function setParam(param, value) {
    const nextQuery = new URLSearchParams(query);
    if (value === "" || value === null || value === undefined) {
      nextQuery.delete(param);
    } else {
      nextQuery.set(param, value);
    }
    return nextQuery;
  }
  return setParam;
}

export function useSetParams() {
  const query = useQuery();
  function setParams(params) {
    const nextQuery = new URLSearchParams(query);
    Object.entries(params).forEach(([param, value]) => {
      if (value === "" || value === null || value === undefined) {
        nextQuery.delete(param);
      } else {
        nextQuery.set(param, value);
      }
    });
    return nextQuery;
  }
  return setParams;
}
